export default "__VITE_ASSET__Dmk04_DV__"